import redirectInterceptor from "@/interceptors/redirect_interceptor";
import router from "@/router";
import { onConfig } from "@/config";

let basicUrl = "";

onConfig((config) => {
  basicUrl = config.VUE_APP_BASIC_URL;
});

const getDefaultState = () => ({
  seriesData: null,
  fetchLoading: false,
  fetchError: null,
});

const state = getDefaultState();

const getters = {
  chartOptions: (state) => ({
    chart: {
      polar: true,
      type: "column",
    },
    title: { text: null },
    tooltip: {
      distance: 5,
      valueSuffix: " %",
      valueDecimals: 1,
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      width: "100%",
      itemStyle: { fontSize: "10px" },
    },
    xAxis: {
      categories: [
        "AHEAD", "22.5", "45", "67.5", "ABEAM", "112.5", "135", "157.5",
        "ASTERN", "202.5", "225", "247.5", "270", "292.5", "315", "337.5"
      ],
      tickmarkPlacement: "on",
    },
    yAxis: { min: 0 },
    plotOptions: {
      series: {
        stacking: "normal",
        pointPlacement: "on",
      },
    },
    credits: { enabled: false },
    series: state.seriesData || [],
  }),

  fetchLoading: (state) => state.fetchLoading,
};

const mutations = {
  SET_LOADING(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_SUCCESS(state, data) {
    state.seriesData = data; // <-- IMPORTANT
    state.fetchLoading = false;
  },
  SET_ERROR(state) {
    state.fetchLoading = false;
    state.fetchError = "Failed to load provider relative wind";
  },
};

const actions = {
  async fetchWeatherRelativeWindData({ commit, rootState }) {
    commit("SET_LOADING");

    try {

      const selected = rootState.main.selectedVessel;
      const vessel = selected && selected.vessel ? selected.vessel : null;
      const selectedLeg = rootState.vesselInformation.selectedLeg;

      if (!vessel || !selectedLeg) {
        commit("SET_ERROR");
        return;
      }

      const startDate = selectedLeg.startDate
        .substring(0, 19)
        .replace("T", " ");

      const stopDate = selectedLeg.stopDate
        .substring(0, 19)
        .replace("T", " ");

      const response = await redirectInterceptor.get(
        basicUrl + "/vesselInformation/" + vessel + "/providerRelativeWind",
        {
          params: { startDate, stopDate },
          headers: {
            Authorization: localStorage.getItem("quad_token"),
          },
        }
      );

      if (response.data.success) {
        commit("SET_SUCCESS", response.data.data);
      } else {
        if (response.data.msg === "rdr") {
          router.push("/login").catch(() => { });
        }
        commit("SET_ERROR");
      }
    } catch (err) {
      commit("SET_ERROR");
    }
  },
};

export const weatherRelativeWindDataModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
